export const cransmontana_translations = {
  tabs: [
    {
      translations: [
        {
          language: { code: "en-US" },
          name: "Day passes",
          cta_label: "Search",
          cta_href:
            "https://mycma.ltibooking.com/en/categories/dynamic-day-pass-1-to-7-day-in-crans-montana",
          search_message: "Search for Tickets & Passes",
          picker_label: "Date"
        },
        {
          language: { code: "it-IT" },
          name: "Pass giornaliero",
          cta_label: "Cerca",
          cta_href:
            "https://mycma.ltibooking.com/it/categories/dynamic-day-pass-1-to-7-day-in-crans-montana",
          search_message: "Cerca per biglietto e pass",
          picker_label: "Data"
        },
        {
          language: { code: "de-DE" },
          name: "Tageskarte",
          cta_label: "Suche",
          cta_href:
            "https://mycma.ltibooking.com/de/categories/dynamic-day-pass-1-to-7-day-in-crans-montana",
          search_message: "Nach Tickets suchen",
          picker_label: "Datum"
        },
        {
          language: { code: "fr-FR" },
          name: "Pass journée",
          cta_label: "Rechercher",
          cta_href:
            "https://mycma.ltibooking.com/fr/categories/dynamic-day-pass-1-to-7-day-in-crans-montana",
          search_message: "Recherche de billets",
          picker_label: "Date"
        },
      ],
      icon: "LiftTicket",
    },
    {
      translations: [
        {
          language: { code: "en-US" },
          name: "Long run passes",
          cta_label: "Search",
          cta_href:
            "https://mycma.ltibooking.com/en/categories/long-run-pass",
          search_message: "Search for Tickets & Passes",
          picker_label: "Date"
        },
        {
          language: { code: "it-IT" },
          name: "Pass lunga durata",
          cta_label: "Cerca",
          cta_href:
            "https://mycma.ltibooking.com/it/categories/long-run-pass",
          search_message: "Cerca per biglietto e pass",
          picker_label  : "Data"
        },
        {
          language: { code: "de-DE" },
          name: "Dauerticket",
          cta_label: "Suche",
          cta_href:
            "https://mycma.ltibooking.com/de/categories/long-run-pass",
          search_message: "Nach Tickets suchen",
          picker_label  : "Datum"
        },
        {
          language: { code: "fr-FR" },
          name: "Pass longue durée",
          cta_label: "Rechercher",
          cta_href:
            "https://mycma.ltibooking.com/fr/categories/long-run-pass",
          search_message: "Recherche de billets",
          picker_label: "Date"
        },
      ],
      icon: "GuestCard",
    },
  ],
};